import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import { AuditorOpenRequestsRoutePage } from '@/components/auditor-center/AuditorOpenRequestsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests',
)({
  // Deep-link target — preselects this thread. Same param name the customer
  // portal's Inbox uses, so a link into either surface reads the same.
  validateSearch: z.object({ commentId: z.string().optional() }),
  // `pad: false` — the page is a full-height two-pane surface like the portal
  // Inbox, so the cycle shell must not wrap it in its p-6 content padding.
  staticData: {
    pageHeader: { title: 'Inbox', customHeader: true, pad: false },
  },
  component: AuditorOpenRequestsRoutePage,
})
